import { Injectable, Injector, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import {
    DatiqRulesEvaluatorService,
    DatiqRulesRegisterService,
    DatiqRulesService,
} from '@dat/datiq-rules';
import {
    IDatiqRulesData,
    IDatiqRulesRule,
    IDatiqRulesServiceEvaluator,
} from '../models';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class IqRulesService {
    constructor(
        private readonly _rules: DatiqRulesEvaluatorService,
        private readonly _register: DatiqRulesRegisterService,
        private readonly _rulesService: DatiqRulesService,
        private injector: Injector,
    ) {}

    passed(rules: IDatiqRulesRule[]): Signal<boolean> {
        const sub: Signal<boolean> = toSignal(
            this._rules.evaluateRules$(rules),
            {
                injector: this.injector,
            },
        ) as Signal<boolean>;

        return sub;
    }

    evaluateRules<T>(rules: IDatiqRulesData<T>[]): Signal<T[]> {
        const sub: Signal<T[]> = toSignal(this._rules.getPassedData$(rules), {
            injector: this.injector,
        }) as Signal<T[]>;

        return sub;
    }

    evaluateRules$<T>(rules: IDatiqRulesData<T>[]): Observable<T[]> {
        return this._rules.getPassedData$(rules) as Observable<T[]>;
    }

    register(type: string, service: IDatiqRulesServiceEvaluator): void {
        return this._register.register(type, service);
    }

    getNoConditionObservable(fnName, type) {
        return this._rulesService.getNoConditionObservable(fnName, type);
    }
}
